import { Card, CardBody, Col} from "reactstrap";
import {  BorderTopText1, BorderTopText2, BorderTopTextEm, TopBorder } from "../../../../Constant";
import { BORDER_TOP } from "../../../../Data/Bonus Ui/CreativeCard";
import CommonCreativeCardHeader from "../Common/CommonCreativeCardHeader";
import { P } from "../../../../AbstractElements";

const BorderTop = () => {
  return (
    <Col sm="12" md="6">
      <Card className="b-t-0">
        <CommonCreativeCardHeader headerClass="border-t-danger border-3" title={TopBorder} span={BORDER_TOP} />
        <CardBody>
        <P className="mb-0">{BorderTopText1}<em className="txt-danger">{BorderTopTextEm}</em>{BorderTopText2}</P>
        </CardBody>
      </Card> 
    </Col>
  )
}

export default BorderTop